import { AuthContext } from 'domain/entities/AuthContext';
import { InjectableHook } from 'domain/types/InjectableHook';

export const AuthContextRepository = Symbol('AuthContextRepository');

export type IAuthContextRepositoryHook = InjectableHook<{
  useAuthContext(): AuthContext | undefined;
  setAuthContext(authContext: AuthContext | undefined): void;
}>;
